import { LoadState } from "../../constants/enums";

export interface IClaimsState {
    list: ICliam[];
    loading: LoadState;
    totalRecords: number;
}

export interface ICliam {
  policy_automobile_driver_claims_dim_id: number;
  customer_policy_id: number;
  customer_id: string;
  incremental_number: number;
  claim_number: string;
  driver_number: string | null;
  vehicle_number: string;
  date_of_loss: string; // Format: YYYY-MM-DD
  claim_type: string;
  amount_paid: string;
  insurer: string;
  at_fault: string; // 'Y' or 'N'
  forgiven: string; // 'Y' or 'N'
  file_upload: string;
  ours: string; // 'Y' or 'N'
  address: string;
  city: string;
  province_or_state: string;
  country: string;
  postal_code: string;
  time_of_loss: string | null;
  value_of_loss: string;
  expiry_date: string | null;
  effective_date: string | null;
  effective_time: string | null;
  policy_number: string | null;
  line_of_business: string | null;
  branch_code: string | null;
  producer_one_code: string | null;
  policy_status: string | null;
  customer_code: string | null;
  customer_name: string | null;
  time: string | null;
  expiry_time: string | null;
  vehicle_information: {
    vin: string;
    make: string;
    prov: string;
    year: string;
    model: string;
    plate_number: string;
    vehicle_number: string;
  }[];
  where_can_vehicle_seen: string | null;
  coverage_information: any; // not specified
  driver_information: any; // not specified
  additional_interests: any; // not specified
  details_of_loss: {
    date: string;
    time: string;
  };
  authority_report: {
    authority: string;
  }[];
  injured_party: any;
  third_party_owner_information: any;
  third_party_vehicle_information: any;
  third_party_driver_information: {
    same_address: boolean;
  };
  third_party_damage_information: any;
  witness_contact_information: any;
  adjuster_assignment_information: any;
  claim_coverage: {
    label: string;
    claim_payment?: string;
  }[];
  claim_payment_total: number | null;
  insurer_id: number | null;
  fixed_id: number | null;
  created_from: string;
  reference_form_id: number | null;
  status: string;
  created_by_id: number;
  create_ts: string; // ISO date string
  insert_ts: string; // ISO date string
}



export const initialClaimsState: IClaimsState = {
    list: [],
    loading: LoadState.NotLoaded,
    totalRecords: 0,
}